import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Tiled Layout"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "tiled-layout"
    }}>{`Tiled Layout`}</h1>
    <p>{`Create a responsive auto-sized tiled layout using CSS Grid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live xray",
        "live": true,
        "xray": true
      }}>{`<div
  sx={{
    display: 'grid',
    gridGap: 3,
    gridTemplateColumns: \`repeat(auto-fit, minmax(128px, 1fr))\`,
  }}>
  <div>One</div>
  <div>Two</div>
  <div>Three</div>
  <div>Four</div>
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

export default ({ gap = 3, width = 128, ...props }) => (
  <div
    {...props}
    sx={{
      display: 'grid',
      gridGap: gap,
      gridTemplateColumns: \`repeat(auto-fit, minmax(\${width}px, 1fr))\`,
    }}
  />
)
`}</code></pre>
    <p>{`See also: `}<a parentName="p" {...{
        "href": "/components/grid"
      }}>{`Grid component`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      